import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@/utils/fn';
import { Chain, CustomerProfile } from './';

export default class CustomerProgram {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
		if (args.customerProgram) Object.assign(args, toCamelCaseProperties(args.customerProgram) || {});

		this.active = !!args.active;
		this.allowSignUp = !!args.allowSignUp;
		this.chainId = args.chainId || 0;
		this.chain = new Chain(args.chain);
		this.customerCategories = args.customerCategories || [];
		this.customerProgramId = args.customerProgramId || 0;
		this.customers = args.customers.map(customer => new CustomerProfile(customer));
		this.defaultCustomerCategoryId = args.defaultCustomerCategoryId || '';
		this.info = args.info || '';
		this.initialPointsStartDate = moment(args.initialPointsStartDate || '');
		this.initialPointsValue = args.initialPointsValue || 0;
		this.isOnline = !!args.isOnline;
		this.programName = args.programName || '';
		this.senderNumber = args.senderNumber || '';
		this.smsText = args.smsText || '';
		this.termsOfUse = args.termsOfUse || '';
		this.timeOfDayToSendSms = args.timeOfDayToSendSms || 0;
		this.useCategoryNameAsDisplayName = !!args.useCategoryNameAsDisplayName;
	}
}
